var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"is-fullwidth",attrs:{"id":_vm.buttonId,"icon-left":"google","type":"is-google"}},[_vm._v("\n    "+_vm._s(_vm.$t('login.social.google'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }